import { ApiResponse } from '../models/api-response.model';
import { environment } from 'src/environments/environment';

export function unwrapConteudo<T>(response: ApiResponse<T>): T {
  if (!response || response.conteudo === undefined) {
    throw new Error('Resposta da API fora do padrao');
  }
  return response.conteudo;
}

export function resolveAvatarUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const base = environment.apiBaseUrl.replace(/\/+$/, '');
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${base}${path}`;
}
